const toUSD = (value) => {
  if (value) return `$${value.toLocaleString()}`;
  return '$0';
};

export default toUSD;
